import { Validators } from '@angular/forms';

export class HomeLoanDetailsModel {
  primaryPurpose = {
    value: null,
    validation: Validators.compose([Validators.required]),
  };
  purposes = {
    value: [],
    validation: Validators.compose([]),
  };
  deposits = {
    value: [],
    validation: Validators.compose([]),
  };
  fees = {
    value: [],
    validation: Validators.compose([]),
  };
  splits = {
    value: [],
    validation: Validators.compose([]),
  };
  purposesSubTotal = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.min(50000)
    ])
  };
  feesFundedTotal = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      // Validators.min(1)
    ])
  };
  feesOtherTotal = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      // Validators.min(1)
    ])
  };
  propertyFound = {
    value: true,
    validation: Validators.compose([
    ])
  };
  depositsTotal = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
    ])
  };
  loanFacilityTotal = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.min(1)
    ])
  };
  unallocatedAmount = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.max(0),
      Validators.min(0)
    ])
  };
  sacrifice = {
    value: null,
    validation: Validators.compose([])
  };
  mortgageInsurance = {
    value: null,
    validation: Validators.compose([])
  };
}

export class IndividualLoanPurposeModel {
  purpose = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  description = {
    value: null,
    validation: Validators.compose([])
  };
  details = {
    value: null,
    validation: Validators.compose([])
  };
  creditProvider = {
    value: null,
    validation: Validators.compose([])
  };
  amount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.min(1)
    ])
  };
}

export class IndividualFeeModel {
  feeType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  feeDescription = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };
  feeAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.min(1),
      Validators.pattern('[0-9.]*')
    ])
  };
  source = { // for fees that need to be referenced
    value: null,
    validation: Validators.compose([])
  };
  maxValidationAmount = { // for fees that need to be referenced
    value: null,
    validation: Validators.compose([])
  };
}

export class IndividualDepositModel {
  depositType = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };
  depositDescription = {
    value: null,
    validation: Validators.compose([])
  };
  depositAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.min(1)
    ])
  };
}

export class IndividualSplitModel {
  product = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  productPricing = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  displayName = {
    value: null,
    validation: Validators.compose([])
  };
  isShariaCompliant = {
    value: false,
    validation: Validators.compose([])
  };
  allowCards = {
    value: false,
    validation: Validators.compose([])
  };
  rate = {
    value: 0,
    validation: Validators.compose([])
  };
  rtb = {
    value: 0,
    validation: Validators.compose([
      Validators.required
    ])
  };
  margin = {
    value: 0,
    validation: Validators.compose([])
  };
  repayment = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  splitAmount = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.min(1)
    ])
  };
  term = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  interestOnlyTerm = {
    value: null,
    validation: Validators.compose([])
  };
  fixedRateTerm = {
    value: null,
    validation: Validators.compose([])
  };
  honeymoon = {
    value: null,
    validation: Validators.compose([])
  };
  isSMSF = {
    value: null,
    validation: Validators.compose([])
  };
  isGreen = {
    value: null,
    validation: Validators.compose([])
  };
  isReferenceRateDisclosed = {
    value: null,
    validation: Validators.compose([])
  };
  adjustment = {
    value: null,
    validation: Validators.compose([])
  };
  adjustmentType = {
    value: null,
    validation: Validators.compose([])
  };
  adjustmentExpiry = {
    value: null,
    validation: Validators.compose([])
  };
  referenceRate = {
    value: null,
    validation: Validators.compose([])
  };
  interestType = {
    value: null,
    validation: Validators.compose([])
  };
}
